import React, { useEffect, useState } from 'react'
import axios from 'axios'
import "../styles/AdminApplications.css"
import Pagination from '@material-ui/lab/Pagination';
import { upperFirst } from 'lodash'
import { useDispatch } from 'react-redux'
import { ApiURL } from '../constants/ApiUrl'
import { useHistory } from 'react-router-dom'
import "../styles/Noticeview.css"
import * as Yup from "yup"
import { LinearProgress, TextField, TextareaAutosize, Select, MenuItem, InputLabel, FormControl, FormHelperText, Button } from '@material-ui/core'
import "../styles/FormPage1.css"

function NoticeMemberPage() {
    const [userType, setuserType] = useState('')
    const [AppList, setAppList] = useState([])
    const [datalist, setDatalist] = useState([])
    const [Page, setPage] = useState(0)
    const [textList, setTextList] = useState([])
    const [TotalPages, setTotalPages] = useState(0)
    const [TotalItems, setTotalItems] = useState(0)
    const [view,setView]=useState(false)
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        getNotices(0, 10)
        getNotices(Page, 10);

    }, [Page, userType])

    const handleView = async (value) => {
        localStorage.setItem("Notice", value)
        history.replace(`/member/NoticeMember/${value}`)
    }
    const viewNotice = () => {
        setAppList(datalist)
        setView(true)

    }
    const handlePageChange = (e, value) => {
        setPage(value - 1);
    }
    const getNotices = async (page, limit) => {
        const textlist = []
        const result2 = JSON.parse(localStorage.getItem("result"))
        if (result2.appType === 'student') {
            setuserType('Student')
        }
        else if (result2.appType === 'single' || result2.appType === 'couple') {
            setuserType('Life Member')
        }
        else {
            setuserType('Associate')
        }
        
        const result = await axios.get(`${ApiURL}/api/get_notices_for_member?page=${page}&limit=${limit}&userType=${userType}`)
        console.log(result, "status")
        
        result.data.data.forEach((element) => {
            const data = element.text.slice(0, 150)
            textlist.push(data)

        })
        const noticedata = []
        result.data.data.forEach((element) => {
            if (noticedata.length < 5) {
                noticedata.push(element)
            }

        })
        setTextList(textlist)
        setAppList(noticedata);
        setDatalist(result.data.data)
        setTotalPages(result.data.totalPages);
        setTotalItems(result.data.totalItems);
    }

    const viewLess=()=>{
        const noticedata = []
        AppList.forEach((element) => {
            if (noticedata.length < 5) {
                noticedata.push(element)
            }

        })
        // setTextList(textlist)
        setAppList(noticedata)
        setView(false)
    }
    return (
        <> <h1>Notices</h1>
            <div className="admMem">
                {/* <div style={{display:"flex" }}>
                   { view? <Button  variant="contained" color="primary" style={{height:"40px",position:"relative",left:"700px",bottom:"45px"}} onClick={viewLess} >View Less</Button>: <Button  variant="contained" color="primary" style={{height:"40px",position:"relative",left:"700px",bottom:"45px"}} onClick={viewNotice}>View More</Button>}
                   
                </div> */}
                <Pagination count={TotalPages} page={Page + 1} onChange={handlePageChange} variant="outlined" shape="rounded" />
                <p><b>{TotalItems} records found.</b></p>
                <table className="appTable">
                    <tr>
                        <th>S.No</th>
                        <th className="notic">User Group</th>
                        <th>Title</th>
                        <th className="notic">Notice</th>
                        <th className="notic">Date</th>
                        <th>Action</th>
                    </tr>
                    {
                        AppList.map((item, index) => (
                            <tr key={item.memberID}>
                                <td>{(Page * 10) + (index + 1)}</td>
                                <td className="notic">{item.userType}</td>
                                <td >{item.subject}</td>
                                <td className="notic"  style={{ width: "560px" }} >{textList[index]}</td>
                                <td className="notic">{new Date(item.createdAt).toDateString()}</td>
                                <td><Button variant="contained" color="primary"
                                    onClick={() => handleView(item._id)}
                                >View</Button></td>
                            </tr>

                        ))
                    }
                </table>
            </div>



        </>
    )
}


export default NoticeMemberPage;
